import { createMongoAbility } from '@casl/ability'
export default (user) => createMongoAbility(user.roleId?.rules)
